import { api, getCurrentUser } from '@creditsights/api-ui-web';
import { Like } from '../../models/Like';
import { LikeDto } from '../dtos/like.dto';
import { PROFILES_MODULE_V1_URI } from '../services.constants';

export const getLikesUri = (userId: string): string => `${PROFILES_MODULE_V1_URI}${userId}/likes`;
const userIdErrorMessage = 'Failed to get user id';

export const fetchLikes = async (): Promise<Like[]> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error(userIdErrorMessage));
  }
  const { data } = await api.get<LikeDto[]>(getLikesUri(userId));
  return data;
};

export const unlike = async (id: string): Promise<void> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error(userIdErrorMessage));
  }
  return api.delete(`${getLikesUri(userId)}/${id}`);
};

export const like = async (id: string): Promise<Like> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return Promise.reject(new Error(userIdErrorMessage));
  }
  const { data } = await api.post<LikeDto>(getLikesUri(userId), { contentId: id });
  return data;
};
